import React from "react";
import { Provider } from "react-redux";

import Flujo from "./flujo.cmpt";

export default class RecuperarContrasenia extends React.Component {

	render() {
		return <Provider store={this.props.redux}>
			<Flujo redux={this.props.redux} 
				hashOne={this.props.hashOne} 
				hashTwo={this.props.hashTwo} 
				hashThree={this.props.hashThree} 
				hashFour={this.props.hashFour} 
				hashFive={this.props.hashFive}
			/>
		</Provider>;
	}
}


// WEBPACK FOOTER //
// ./src/gnp-recuperar-contrasenia/contenedor.cmpt.js